import { kebabCase } from 'lodash-es';

import { CITY_CLUSTER } from '@shared/constants/homepage-clusters';

import Headline from '../headline/Headline';
import MobileCarousel from '../mobile-carousel/MobileCarousel';
import CityCard from './CityCard';

type CityClusterProps = {
  titleKey?: string;
  subtitleKey?: string;
  titleValues?: Record<string, string>;
  cities?: string[];
};

const IMAGE_BASE_PATH = '/assets/homepage-city-cluster/';

const CityCluster = ({ titleKey = 'landingPage:cityCluster.title', subtitleKey, titleValues, cities = CITY_CLUSTER }: CityClusterProps) => (
  <div className='container mx-auto'>
    <Headline
      i18nKey={titleKey}
      subTitle={subtitleKey}
      subTitleClassName='mx-auto w-full md:w-1/2'
      titleValues={titleValues}
      showArrow
      arrowPosition='right'
    />
    <div className='hidden lg:grid lg:grid-cols-3 lg:items-start lg:justify-center lg:gap-4'>
      {cities.map((city, index) => (
        <CityCard
          city={city}
          fallbackImageSrc={`${IMAGE_BASE_PATH}fallback_${index}.jpg`}
          imageSrc={`${IMAGE_BASE_PATH}${kebabCase(city)}.jpg`}
          key={city}
        />
      ))}
    </div>
    <div className='w-full lg:hidden'>
      <MobileCarousel
        elements={cities.map((city, index) => (
          <div key={city} className='w-full shrink-0 sm:w-full md:w-1/2'>
            <CityCard
              city={city}
              imageSrc={`${IMAGE_BASE_PATH}${kebabCase(city)}.jpg`}
              fallbackImageSrc={`${IMAGE_BASE_PATH}fallback_${index}.jpg`}
            />
          </div>
        ))}
      />
    </div>
  </div>
);

export default CityCluster;
